import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-candlestick-series-options',
	templateUrl:'./AgCandlestickSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgCandlestickSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgCandlestickSeriesPluginCompPage
{
	mdContent_701 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgCandlestickSeriesOptions;
\`\`\``;
}
